export type Actions =
  | { type: ActionTypes.SetCollapsable; collapseId: string }
  | { type: ActionTypes.SetHasActions }
  | { type: ActionTypes.UnsetCollapsable }
  | { type: ActionTypes.UnsetHasActions }
  | { type: ActionTypes.ToggleOpen }

export enum ActionTypes {
  SetCollapsable,
  SetHasActions,
  UnsetCollapsable,
  UnsetHasActions,
  ToggleOpen,
}
